import { Link, useHistory } from "react-router-dom";
import React, { useContext, useEffect, useMemo, useState } from "react";
import "moment/locale/fr";
import { UserContext } from "../../App";
import { db } from "../../index";

export default function PaidSubscriptionContent() {
  const { userInfos } = useContext(UserContext);
  const history = useHistory();

  const [subscriptionStatus, setSubscriptionStatus] = useState("");

  useEffect(() => {
    //listen to firebase db /users/userInfos.uid/info/subscription updates
    if (!userInfos.uid) return;

    db.ref(`/users/${userInfos.uid}/info/subscription`).on(
      "value",
      (snapshot) => {
        const subscription = snapshot.val();

        if (subscription?.status === "active") {
          history.push("/");
        } else {
          setSubscriptionStatus(subscription?.status);
        }
      }
    );
  }, [history, userInfos.uid]);

  const text = useMemo(() => {
    if (!subscriptionStatus) {
      return "Loading...";
    } else if (subscriptionStatus === "active") {
      return (
        <>
          Your payment has been successfully received, you will be redirected to
          the <Link to="/">home page</Link>.
        </>
      );
    } else {
      return (
        <>
          There was an issue with the payment,{" "}
          <Link to="/subscription">please try again</Link>.
          <br />
          <small>Subscription status: {subscriptionStatus}</small>
        </>
      );
    }
  }, [subscriptionStatus]);

  return (
    <div
      className="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
      id="kt_content"
    >
      <div className="kt-subheader kt-grid__item" id="kt_subheader">
        <div className="kt-container  kt-container--fluid ">
          <div className="kt-subheader__main"></div>
        </div>
      </div>
      <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
        <div className="kt-portlet kt-portlet--tabs">
          <div className="kt-portlet__head">
            <div className="kt-portlet__head-label w-100 d-flex justify-content-between">
              <h3 className="kt-portlet__head-title">Redirect</h3>
            </div>
          </div>
          <div>
            {text}
          </div>
        </div>
      </div>
    </div>
  );
}